import React, { Component, Fragment }from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import slug from 'slug'

import '../styles/slugifier.scss'

class Slugifier extends Component {
  constructor(props) {
    super(props);
    this.onChangeSource = this.onChangeSource.bind(this);
    this.state = {
      source: '',
      slugified: ''
    };
  }

  onChangeSource(e) {
    const value = e.target.value;
    this.setState({
      source: value,
      slugified: slug(value)
    });
  }

  render() {
    const { data } = this.props;
    return (
      <div className="slugifier">
        <Helmet
          title={`Slugifier - ${data.site.siteMetadata.title}`}
          meta={[
            { name: 'description', content:  data.site.siteMetadata.description}
          ]}
        />
        <h2>Enter a set of words and a stringified version will be computed</h2>
        <div>
          <span className="field-label">Original:</span>
          <input 
            type="text" 
            value={this.state.source}
            placeholder="quick brown fox jumped"
            onChange={this.onChangeSource}  
          />
        </div>

        <div>
          <span className="field-label">Slugified:</span>
          <input 
            type="text" 
            value={this.state.slugified}
          />
        </div>
      </div>
    )
  }

}

Slugifier.propTypes = {

}

export default Slugifier;

export const query = graphql`
  query SlugifierTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/slugifier.js